<template>
  <div>
    <HomeSection />
    <AboutSection class="hidden"/>
    <ServicesSection class="hidden"/>
    <ProcessSection class="hidden"/>
    <ReviewsSection />
  </div>
</template>

<script>
import HomeSection from '../components/HomeSection.vue'
import AboutSection from '../components/AboutSection.vue'
import ServicesSection from '../components/ServicesSection.vue'
import ProcessSection from '../components/ProcessSection.vue'
import ReviewsSection from '../components/ReviewsSection.vue'



export default {
  name: 'Home',
  components: {
    HomeSection,
    AboutSection,
    ServicesSection,
    ProcessSection,
    ReviewsSection
  },
     mounted(){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Tandzorg Gestel | Tandarts Sint-Michielsgestel | Nieuwe Patiënten Welkom"
      document.querySelector('meta[name="description"]').setAttribute("content", "Tandzorg Gestel in Sint-Michielsgestel. Ervaren tandartspraktijk met persoonlijke aandacht, moderne technieken en zorg zonder zorgen. Nieuwe patiënten welkom!");
      this.$store.commit('updateActivePage', 'Home') 

      if(this.$store.state.scrollToRegisterSection == true) {
        const element = document.getElementById('register-section');
        element.scrollIntoView({ behavior: 'smooth' });
      }

      if(this.$store.state.scrollToAppointmentSection == true) {
        const element = document.getElementById('register-section-appointment');
        element.scrollIntoView({ behavior: 'smooth' });
      }

      console.log(this.$store.state.activePage)
    }
};
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}

</style>
